import axios from 'axios';

const instance = new axios.create({
  xsrfCookieName: 'CRAFT_CSRF_TOKEN',
  xsrfHeaderName: 'X-CSRF-Token'
})

instance.defaults.headers.post['X-CSRF-Token'] = window.csrfTokenValue

export default instance